import { create } from './customCreate';

interface SearchState {
  query: string;
  setQuery: (value: string) => void;
  clear: () => void;
}

export const useSearchStore = create<SearchState>()((set) => ({
  query: '',
  setQuery: (query) => set({ query }),
  clear: () => set({ query: '' }),
}));
